import styled from 'styled-components';

export const MatchingPageLayout = styled.div`
  position: relative;
  z-index: 1;
  min-height: 100vh;
  background: #f7fafc;
  max-width: 1280px;
  margin: 0 auto;
  padding: 28px 36px 64px;
  color: #18283b;
  .matching-back {
    display: inline-flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 20px;
  }
  .matching-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 28px;
  }
  h1 {
    font-size: 28px;
    line-height: 1.3;
    letter-spacing: -0.6px;
    margin: 0 0 8px;
    overflow-wrap: anywhere;
  }
  h2 {
    font-size: 20px;
    line-height: 1.4;
    margin: 0 0 16px;
  }
  h3 {
    font-size: 16px;
    margin: 0;
  }
  p {
    line-height: 1.65;
  }
  .matching-muted {
    color: #64748b;
    font-size: 13px;
  }
  .matching-filters {
    padding: 20px 0;
    border-top: 1px solid #dce4ed;
    border-bottom: 1px solid #dce4ed;
    margin-bottom: 20px;
  }
  .matching-filter-fields {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 16px;
  }
  .matching-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 150px;
  }
  .matching-field label {
    font-size: 13px;
    font-weight: 500;
  }
  .matching-field .ant-select {
    min-width: 190px;
  }
  .matching-field .ant-input-number {
    width: 120px;
  }
  .matching-filter-actions {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-top: 12px;
    flex-wrap: wrap;
  }
  .matching-advanced {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e5eaf0;
  }
  .matching-results-heading {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: baseline;
    margin: 20px 0 12px;
  }
  .ant-alert {
    margin-bottom: 16px;
  }
  .matching-results-count {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 12px;
    align-items: baseline;
  }
  .matching-reasons {
    margin: 0;
    padding-left: 20px;
  }
  .matching-table .ant-table {
    background: transparent;
  }
  .matching-table .ant-table-thead > tr > th {
    background: #eef2f6;
    color: #526174;
    font-size: 12px;
    font-weight: 500;
    border-bottom-color: #dce4ed;
  }
  .matching-table .ant-table-thead > tr > th::before {
    display: none;
  }
  .matching-table .ant-table-tbody > tr > td {
    background: white;
    padding: 18px 16px;
    border-bottom-color: #e8edf2;
    vertical-align: top;
  }
  .matching-table .ant-table-tbody > tr:hover > td {
    background: #f1f6fc;
  }
  .matching-row {
    cursor: pointer;
  }
  .matching-name {
    color: #183955;
    font-weight: 600;
    font-size: 15px;
    line-height: 1.5;
    overflow-wrap: anywhere;
  }
  .matching-secondary {
    margin-top: 4px;
    font-size: 13px;
    color: #64748b;
  }
  .matching-row-flags {
    margin-top: 6px;
    font-size: 12px;
    color: #966119;
  }
  .matching-mobile-meta {
    display: none;
  }
  .matching-score {
    font-weight: 600;
    font-size: 22px;
    font-variant-numeric: tabular-nums;
    line-height: 1.2;
  }
  .matching-score small {
    font-size: 12px;
    color: #64748b;
    font-weight: 400;
  }
  .matching-technical {
    margin-top: 24px;
    background: transparent;
    border-color: #dce4ed;
  }
  .matching-technical .ant-collapse-header {
    color: #64748b;
    font-size: 13px;
  }
  .matching-technical .ant-descriptions-item-content {
    overflow-wrap: anywhere;
  }
  .matching-overview {
    background: white;
    padding: 28px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    margin: 24px 0 32px;
    display: grid;
    grid-template-columns: 150px minmax(0, 1fr);
    gap: 28px;
  }
  .matching-overview .matching-score {
    font-size: 44px;
    margin: 8px 0;
  }
  .matching-detail-section {
    margin-top: 32px;
  }
  .matching-categories {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0 32px;
  }
  .matching-category {
    padding: 20px 0;
    border-top: 1px solid #dce4ed;
  }
  .matching-category-heading {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
    margin-bottom: 8px;
  }
  .matching-category p {
    margin: 0;
    color: #526174;
  }
  .matching-findings {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .matching-findings li {
    padding: 16px 0;
    border-top: 1px solid #dce4ed;
  }
  .matching-findings p {
    margin: 8px 0 0;
  }
  .matching-detail-context {
    display: flex;
    gap: 8px 24px;
    flex-wrap: wrap;
    margin-top: 12px;
  }
  .matching-detail-header {
    margin-bottom: 12px;
  }
  .matching-empty {
    padding: 48px 16px;
  }
  @media (max-width: 991px) {
    padding: 24px 20px 48px;
    .matching-header {
      gap: 16px;
      flex-wrap: wrap;
    }
    h1 {
      font-size: 24px;
    }
    .matching-table .matching-desktop-column {
      display: none;
    }
    .matching-mobile-meta {
      display: block;
    }
    .matching-table .ant-table-tbody > tr > td {
      padding: 16px 12px;
    }
  }
  @media (max-width: 480px) {
    padding: 20px 14px 40px;
    .matching-field {
      flex: 1;
      min-width: 120px;
    }
    .matching-field .ant-select {
      min-width: 0;
      width: 100%;
    }
    .matching-field .ant-input-number {
      width: 100%;
    }
    .matching-overview {
      padding: 20px;
      grid-template-columns: 1fr;
      gap: 16px;
    }
    .matching-categories {
      grid-template-columns: 1fr;
    }
    .matching-results-heading {
      align-items: flex-start;
      flex-direction: column;
      gap: 4px;
    }
  }
`;
